<template>
  <div v-if="isshare">
      <div class="mcover" id="mcover" @click="()=>{$emit('click',false)}">
        <img :src="tishi" alt="">
    </div>
  </div>
</template>
<script>
import tishi from "@/assets/images/tishi.png";
export default {
  components: {

  },
  name: '',
  props: {
      isshare: Boolean,
  },
  data() {
    return {
        tishi,
        shared: false,
    }
  },
  mounted(){

  },
  computed:{

  },
  methods:{
      
  },
}
</script>
<style scoped lang="scss">
.mcover{
    background: rgba(0, 0, 0, 0.8);
    z-index: 2099;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}
.mcover img{
    width: 50%;
    float: right;
    padding-top: 0.1rem;
    margin-right: 60rem;
}

</style>
